import { render } from "./MediaPlayerWithSources.vue?vue&type=template&id=a60e0c50"
import script from "./MediaPlayerWithSources.vue?vue&type=script&lang=js"
export * from "./MediaPlayerWithSources.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__